module.exports = __webpack_public_path__ + "static/media/Postbank.782c55d9.svg";